import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "batchmenu",
  "use": "batchmenu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"batchmenu\"><defs><style>#batchmenu .cls-1{fill:none}</style></defs><title>资源 75</title><g id=\"batchmenu_图层_2\" data-name=\"图层 2\"><g id=\"batchmenu_图层_1-2\" data-name=\"图层 1\"><path id=\"batchmenu_Rectangle_37_Copy_27\" data-name=\"Rectangle 37 Copy 27\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"batchmenu_copy\"><path id=\"batchmenu_Shape\" d=\"M4.72 24A1.69 1.69 0 0 1 3 22.32V4.7A1.7 1.7 0 0 1 4.72 3H6V1.69A1.7 1.7 0 0 1 7.73 0h6.59a1.57 1.57 0 0 1 .68.15h.15a1.76 1.76 0 0 1 .34.27l5 5.07A1.67 1.67 0 0 1 21 6.76v12.55A1.66 1.66 0 0 1 19.37 21H18v1.32A1.66 1.66 0 0 1 16.36 24H4.72zm0-1.69h11.6V21H7.73A1.7 1.7 0 0 1 6 19.31V4.69H4.71zm3-3h11.6V7.5h-4.1a1.7 1.7 0 0 1-1.72-1.69V1.69H7.71zm2.16-2.62a.85.85 0 1 1 0-1.69h5.81a.85.85 0 0 1 0 1.69H9.87zm0-3a.85.85 0 0 1 0-1.69h7.31a.85.85 0 0 1 0 1.69H9.87zm0-3A.85.85 0 1 1 9.87 9h4.31a.85.85 0 0 1 0 1.69z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/batchmenu.svg
// module id = WqPv
// module chunks = 6